import {ReactComponent as FaUserMd} from '../../assets/icons/FaUserMd.svg'
import {ReactComponent as FaUsers} from '../../assets/icons/FaUsers.svg'
import {ReactComponent as MdDevices} from '../../assets/icons/MdDevices.svg'
import {ReactComponent as RiHospitalLine} from '../../assets/icons/RiHospitalLine.svg'

import {convertKeyToLabel} from '../table-utils/TableUtils'

export function convertLabelListToObjectList(dataList) {
    if (!dataList || !Array.isArray(dataList)) {
        return []
    }

    let returnedList = []
    for (let i = 0; i < dataList.length; i++) {
        if (dataList[i]) {
            let item = {
                label: dataList[i]
                    ? convertKeyToLabel(dataList[i])
                    : dataList[i],
                value: dataList[i],
            }
            returnedList.push(item)
        }
    }
    return returnedList
}

export function convertKeyToOptionsList(columnList) {
    if (!columnList || !Array.isArray(columnList) || columnList.length < 1) {
        return
    }
    let optionsList = []
    for (let i = 0; i < columnList.length; i++) {
        let item = {
            label: convertKeyToLabel(columnList[i].key),
            value: columnList[i].key,
        }
        optionsList.push(item)
    }
    return optionsList
}

export const informationList = [
    {
        key: 'numberOfHospitals',
        label: 'HOSPITALS',
        icon: (
            <RiHospitalLine
                className="mr-2"
                style={{
                    height: '16px',
                    width: '16px',
                }}
            />
        ),
    },
    {
        key: 'numberOfHCPs',
        label: 'H.C PRACTITIONER',
        icon: (
            <FaUserMd
                className="mr-2"
                style={{
                    height: '16px',
                    width: '16px',
                }}
            />
        ),
    },
    {
        key: 'numberOfPatients',
        label: 'PATIENTS',
        icon: (
            <FaUsers className="mr-2" style={{height: '16px', width: '16px'}} />
        ),
    },
    {
        key: 'numberOfDevices',
        label: 'DEVICES',
        icon: (
            <MdDevices
                className="mr-2"
                style={{
                    height: '16px',
                    width: '16px',
                }}
            />
        ),
    },
]
